import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Slider} from '@/app/core/models/slider';
import { environment } from '@/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class SliderService {

	constructor(
		private readonly http: HttpClient
	) {}

	getAllActiveSlider(): Observable<Slider[]> {
		return this.http.get<Slider[]>(`${environment.backendUrl}/slider/active`);
	}
}
